<template>
    <v-card>
        <v-card-text>
            <v-toolbar dark flat color="secondary">
                <v-btn icon @click="close">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('Löschen bestätigen') }}</v-toolbar-title>
            </v-toolbar>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12>
                        <span>{{ $t('Sind Sie sicher, dass Sie die folgende FAQ-Gruppe löschen wollen') }}</span>
                        <span class="px-2">:</span>
                        <span class="primary--text">{{ value.name }}</span>
                    </v-flex>
                    <v-flex xs12>
                        <v-checkbox
                            v-model="confirmDelete"
                            :label="$t('Bestätigen')"
                            :hint="$t('Wenn Sie bereits gelöschte Daten wieder herstellen möchten, wenden Sie sich bitte an den Support.')"
                            persistent-hint
                        />
                    </v-flex>
                </v-layout>
            </v-container>
            <v-card-actions>
                <v-btn block color="error" :disabled="!confirmDelete" @click="submit">
                    {{ $t('Löschen') }}
                </v-btn>
            </v-card-actions>
        </v-card-text>
    </v-card>
</template>

<script>
import FAQMixins from '../Mixins/FAQMixins';

export default {
    name: 'faq-group-delete-confirm',
    mixins: [FAQMixins],
    data: () => ({
        confirmDelete: false
    }),
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        onSubmit: {
            type: Function,
            default: () => ({})
        },
        onClose: {
            type: Function,
            default: () => ({})
        }
    },
    methods: {
        submit() {
            this.SET_SELECTED_FAQ_GROUP({});
            this.onSubmit()(this.value);
        },
        close() {
            this.onClose();
        }
    },
    activated() {
        this.confirmDelete = false;
    }
};
</script>
